import { Product } from "../types";
import apiClient from "./apiClient";

interface FavoritesResponse {
  result: Product[];
  total: number;
}

// Сколько избранного просим за один запрос. Раньше по умолчанию грузилось 10,
// и у пользователя с большим списком остальные товары просто не показывались.
const PAGE_SIZE = 100;

// Получение избранного
export const getFavorites = async (limit: number = PAGE_SIZE, offset: number = 0): Promise<FavoritesResponse> => {
  const response = await apiClient.get("/api/favorites", { params: { limit, offset } });
  // Предполагается, что сервер возвращает список продуктов по ключу `result`.
  return {
    result: response.data.result || [],
    total: response.data.total || 0
  };
};

// Всё избранное целиком: дочитываем страницы, пока не соберём весь список.
export const getAllFavorites = async (): Promise<FavoritesResponse> => {
  const first = await getFavorites(PAGE_SIZE, 0);
  const items = [...first.result];

  while (items.length < first.total && first.result.length > 0) {
    const next = await getFavorites(PAGE_SIZE, items.length);
    if (next.result.length === 0) break;
    items.push(...next.result);
  }

  return { result: items, total: first.total || items.length };
};

// Добавление в избранное
export const addToFavorites = async (product_id: number): Promise<void> => {
  await apiClient.post("/api/favorites", { product_id });
};

// Удаление из избранного
export const removeFromFavorites = async (product_id: number): Promise<void> => {
  await apiClient.delete("/api/favorites", { data: { product_id } });
};

// Переносим избранное, набранное до входа, в аккаунт. Без этого серверный
// список просто затирал локальный, и после входа сердечки «пропадали».
export const mergeGuestFavorites = async (): Promise<void> => {
  let guestFavorites: Product[] = [];
  try {
    guestFavorites = JSON.parse(localStorage.getItem("favorites") || "[]");
  } catch {
    guestFavorites = [];
  }

  if (!Array.isArray(guestFavorites) || guestFavorites.length === 0) return;

  for (const item of guestFavorites) {
    if (!item?.id) continue;
    try {
      await addToFavorites(item.id);
    } catch (error) {
      // Один непереехавший товар не должен ломать вход целиком.
      console.error("Не удалось перенести товар в избранное аккаунта:", error);
    }
  }
};
